import gql from "graphql-tag";

export const susWithdrawalsList = gql`
  query susWithdrawalsList(
    $from: String
    $to: String
    $offset: Int
    $limit: Int
  ) {
    fraud {
      users_with_suspicious_withdrawals(
        from: $from
        to: $to
        offset: $offset
        limit: $limit
      ) {
        total_friend_connection_count
        total_onsend_amount_for_user
        total_topup_amount_for_user
        total_p2p_amount_for_user
        total_withdrawal_amount_for_user
        user {
          email
          external_reference
          dashboard_url
          snapmin_url
          devices {
            external_reference
            device_only_fraud_status
          }
        }
      }
    }
  }
`;
